module.exports = __webpack_public_path__ + "img/pa.a5fc454b.svg";